import { Injectable } from '@angular/core';

import { TrialInsightsChartModel } from '../../models/trial-insights-chart.model';
import {
  TrialInsightsLegendDataOptions,
  TrialInsightsLegendOptions,
} from '../../models/trial-insights-legend.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsClinicalScreenFailChartService implements TrialInsightsChartModel {
  createLegend = (data: TrialInsightsLegendDataOptions[] = []): TrialInsightsLegendOptions => {
    return {
      centered: false,
      color: '',
      compact: false,
      data,
      divider: false,
    };
  };
}
